import React from 'react';
import { Link } from 'react-router-dom';
import 'src/views/managestaff/Overview.css';
import { BsHandIndexThumbFill, BsCalendarWeekFill } from "react-icons/bs";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { FaFaceSmile } from "react-icons/fa6";
import { GoArrowRight } from "react-icons/go";

const Overview = ({ overviewData }) => {
  const data = [
    {
      no: overviewData.monthlyAttendance,
      label: 'MONTHLY PRESENT',
      color: '#FF5E1B',
      icon: <BsHandIndexThumbFill style={{ color: '#fff' }} />,
      title: 'Monthly Present',
    },
    {
      no: overviewData.todayAppointments,
      label: 'TODAY APPOINTMENTS',
      color: '#03C4A9',
      icon: <BsCalendarWeekFill style={{ color: '#fff' }} />,
      title: 'Appointments',
    },
    {
      no: overviewData.totalSalary,
      label: 'TOTAL SALARY',
      color: '#3071FE',
      icon: <RiMoneyRupeeCircleFill style={{ color: '#fff' }} />,
      title: 'Salary',
    },
    {
      no: overviewData.totalIncentive,
      label: 'TOTAL INCENTIVE',
      color: '#FBCA0E',
      icon: <FaFaceSmile style={{ color: '#fff' }} />,
      title: 'Incentive',
    },
  ];

  return (
    <div className="overview-container">
      {/* <h2 className="overview-title">Overview</h2> */}
      <div className="overview-grid">
        {data.map((item, index) => (
          <div className="overview-card" style={{ backgroundColor: item.color }} key={index}>
            <div className="overview-card-header">
              <div className="overview-card-icon">{item.icon}</div>
              <Link to={item.href} className="overview-card-link"
                style={{
                  '--item-color': item.color,
                }}>
                <GoArrowRight />
              </Link>
            </div>
            <div className="overview-card-number">{item.no}</div>
            <div className="overview-card-label">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Overview;
